<template>

	<span>

		<b-link
			v-if="editable"
			class="float-right ml-3"
			@click.prevent="saveClick"
			title="Save section"
		>
			<b-icon
				font-scale="1.5"
				icon="check-square"
                variant="success"
			></b-icon>
		</b-link>

		<b-link
			v-else
			class="float-right ml-3"
			@click.prevent="editClick"
			title="Edit section"
		>
			<b-icon
				font-scale="1.6"
				icon="pencil-square"
			></b-icon>
		</b-link>

	</span>

</template>

<script>
export default {
	name: "SaveOrEditRow",

	props: ["section", "editable"],

	methods: {
		editClick() {
			this.$emit("edit", this.section);
		},
		saveClick() {
			this.$emit("save", this.section);
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/save-or-edit-buttons.vue